import React from 'react'

const About = () => {
  return (
    <div>
      <h1>Sobre</h1>
    </div>
  )
}

export default About